<div class="fb-toolbar">
  <div class="fb-toolbar__group">
    <button
      class="fb-toolbar__btn"
      [disabled]="!canUndo"
      (click)="onUndo()"
      title="Undo (Ctrl+Z)">
      <i class="fa-solid fa-rotate-left"></i>
    </button>
    <button
      class="fb-toolbar__btn"
      [disabled]="!canRedo"
      (click)="onRedo()"
      title="Redo (Ctrl+Shift+Z)">
      <i class="fa-solid fa-rotate-right"></i>
    </button>
  </div>

  <div class="fb-toolbar__separator"></div>

  <div class="fb-toolbar__group">
    <button
      class="fb-toolbar__btn"
      [class.active]="builderMode === 'preview'"
      (click)="onTogglePreview()"
      [title]="builderMode === 'preview' ? 'Back to Builder' : 'Preview Form'">
      <i
        [class]="
          builderMode === 'preview' ? 'fa-solid fa-pen' : 'fa-solid fa-eye'
        "></i>
      <span>{{ builderMode === 'preview' ? 'Edit' : 'Preview' }}</span>
    </button>
  </div>

  <div class="fb-toolbar__separator"></div>

  <div class="fb-toolbar__group">
    <button
      class="fb-toolbar__btn"
      [class.active]="outlineVisible"
      (click)="onToggleOutline()"
      title="Toggle Form Outline">
      <i class="fa-solid fa-list-tree"></i>
      <span>Outline</span>
    </button>
  </div>
</div>
